import { gameArea } from "../utils/gameArea";
import game from "../game";
import GameScene, { GameModes } from "./GameScene";
import SoundManager from "../managers/SoundManager";
import SliderInput from "../ui/SliderInput";

export default class MainMenuScene extends Phaser.Scene {
    titleText: Phaser.GameObjects.Text;
    playGameText: Phaser.GameObjects.Text;
    exitText: Phaser.GameObjects.Text;
    CRTPipeline: any;
    background: Phaser.GameObjects.TileSprite;
    sfx: any;
    volume: SliderInput;

    constructor(){
        super({ key: 'MainMenuScene' });
    }

    preload(){
        const renderer = < Phaser.Renderer.WebGL.WebGLRenderer>game.renderer;
        this.CRTPipeline = renderer.getPipeline('CRT');
    }

    create(){
        this.background = this.add.tileSprite(gameArea.screenWidth/2,gameArea.screenHeight/2,0,0,'backgroundTile')
        this.cameras.main.setRenderToTexture(this.CRTPipeline);
        this.cameras.main.setBackgroundColor("#2e0040");

        const tenth = gameArea.screenHeight/10;

        this.titleText = this.add.text(gameArea.screenWidth/2,tenth*3,"Arena Futura.", { fontFamily: "Practice", fontSize: 160, textAlign: "center", stroke: '#000', strokeThickness: 6 });
        this.titleText.setOrigin(0.5);

        this.playGameText = this.add.text(gameArea.screenWidth/2,tenth*6,"Play.", { fontFamily: "Practice", fontSize: 60, stroke: '#000', strokeThickness: 3 });
        this.playGameText.setOrigin(0.5);
        this.playGameText.setAlpha(1);
        this.playGameText.setInteractive();
        this.playGameText.input.cursor = "pointer";
        this.playGameText.on('pointerover', ()=>{
            SoundManager.playSfx('menuChange');
        });
        this.playGameText.on('pointerdown', ()=>{
            const gscene = <GameScene>this.scene.get('GameScene');
            gscene.currentArenaFight = 0;
            gscene.scene.resume();
            gscene.scene.setVisible(true);
            gscene.setMode(GameModes.INIT);
            this.scene.sleep();
            SoundManager.playSfx('menuSelect');
        });

        this.sfx = new SliderInput(
            this,
            50,
            tenth*8, 'sfx',  { fontFamily: 'Practice', fontSize: 40, stroke: '#000', strokeThickness: 3 });
        this.sfx.value = SoundManager.sfxVolume;
        this.sfx.onChange = (v)=> { SoundManager.sfxVolume = v; }
        this.add.existing(this.sfx);
        this.sfx.sliderPoint.on('pointerdown', ()=>{ SoundManager.playSfx('menuChange'); });
        this.sfx.sliderPoint.on('pointerup', ()=>{ SoundManager.playSfx('menuChange'); });

        this.volume = new SliderInput(
            this,
            50,
            tenth*9, 'music',  { fontFamily: 'Practice', fontSize: 40, stroke: '#000', strokeThickness: 3 });
        this.volume.value = SoundManager.musicVolume;
        this.volume.onChange = (v)=> { SoundManager.musicVolume = v; }
        this.add.existing(this.volume);
        this.volume.sliderPoint.on('pointerdown', ()=>{ SoundManager.playSfx('menuChange'); });
        this.volume.sliderPoint.on('pointerup', ()=>{ SoundManager.playSfx('menuChange'); });


    }

    reinit(){
        this.CRTPipeline.intensity = 0.1;
        SoundManager.playMusic("menuTheme");
    }



    update(time,delta){
        this.CRTPipeline.time+=delta;
        this.background.tilePositionY += 1;
      }

}